import { css } from '@compiled/react';

import { Accordion, AccordionSize, type AccordionTabProps } from '@atlassian/learning-components';
import { MOBILE } from '../../utils/constants';
import Heading from '../common/Heading';

/* styles */

const faqContainerStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1440px;
  width: 100%;
  margin: 112px auto;
  padding: 0 20px;
`;

const faqTitleStyles = css`
  font-family: 'Charlie Display';
  text-align: center;
  margin-bottom: 40px;
  font-size: 40px;
  font-weight: 700;

  ${MOBILE.MEDIA_QUERY} {
    font-size: 32px;
  }
`;

const faqContentStyles = css`
  h4 {
    font-family: 'Charlie Display';
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
  }
  p {
    font-family: 'Inter';
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
  }
`;

const accordionContainerStyles = css({
  maxWidth: '816px',
  width: '100%',
});

/* texts */
const Q1 = 'How do I maintain my Atlassian Champion status?';
const Q2 = 'Can I join more than one Atlassian Champion track?';

const A1 = (
  <div css={faqContentStyles}>
    <h4>Community Champions</h4>
    <p>
      To keep your Champion status, you must complete at least one of the following activities each quarter (90 days):
    </p>
    <ul>
      <li>Organize and host an Atlassian community event.</li>
      <li>
        Contribute to the Atlassian Community Forums: writing articles, generating discussions, or answering questions
        earning at least 200 points.
      </li>
      <li>
        Post at least two pieces of original, Atlassian-focused thought leadership or learning content on social media
        each month.
      </li>
      <li>Contribute to an Atlassian Certification development project (with a minimum of three projects per year).</li>
      <li>Present at an Atlassian Community Event.</li>
      <li>
        Host a company user group or knowledge-sharing event (for example, a brown bag talk) in your organization.
      </li>
      <li>Host a study group for Atlassian Certification preparation in your organization.</li>
    </ul>
    <p>
      If you contribute to more than one activity you are not required to fulfill the quarterly commitments for every
      single activity you are part of. As long as you are contributing to the full requirements for at least one you
      will retain your Atlassian Champion status.
    </p>
    <h4>Success Champions</h4>
    <p>
      While in Beta, activity criteria for Success Champions will be discussed at the time of onboarding into the
      program.
    </p>
  </div>
);

const A2 = (
  <div css={faqContentStyles}>
    <p>
      Yes, Atlassian customers can apply for both the Community Champion and Success Champion tracks. Solution and
      Marketplace Partners can apply for the Community Champion track.
    </p>
  </div>
);

const tabsContent: AccordionTabProps[] = [
  {
    title: Q1,
    isExpanded: false,
    children: A1,
  },
  {
    title: Q2,
    isExpanded: false,
    children: A2,
  },
];

export const FAQ = () => {
  return (
    <section css={faqContainerStyles}>
      <Heading level={2} css={faqTitleStyles}>
        FAQs
      </Heading>
      <div css={accordionContainerStyles}>
        <Accordion
          tabsContent={tabsContent}
          size={AccordionSize.WIDE}
          shouldSingleTabBeOpen={true}
          onChange={() => {}}
        />
      </div>
    </section>
  );
};
